import { booleanAttribute, Component, input, TemplateRef, viewChild } from '@angular/core';
import { JoiiIcon } from '../../icons/lucide/icon';

@Component({
  selector: 'joii-tab',
  imports: [],
  template: `
    <ng-template #content>
      <ng-content />
    </ng-template>
  `,
})
export class TabComponent {
  /**
   * The value of the tab.
   */
  readonly value = input<string>();

  /**
   * The label of the tab.
   */
  readonly label = input<string>();

  /**
   * The content of the tab.
   */
  readonly content = viewChild.required<TemplateRef<void>>('content');

  /**
   * Prefix icon of the tab.
   */
  readonly prefixIcon = input<JoiiIcon>();

  /**
   * Suffix icon of the tab.
   */
  readonly suffixIcon = input<JoiiIcon>();

  /**
   * Optional automation ID forwarded to the rendered tab button for e2e selectors.
   */
  readonly automationId = input<string>();

  /**
   * Whether the tab is disabled. Disabled tabs cannot be selected via click or focus.
   * @default false
   */
  readonly disabled = input(false, {
    transform: booleanAttribute,
  });
}
